package com.bikompanion.domain

data class BoundingBox(
    val south: Double,
    val west: Double,
    val north: Double,
    val east: Double,
) {
    /**
     * Whether two boxes share any ground at all.
     *
     * Touching edges count: a network whose service area stops exactly at the edge of the
     * viewport still has stations on that line.
     *
     * No antimeridian handling. Every box here is built from one operator's stations, and an
     * operator whose network straddles longitude 180 would need more than a box anyway.
     */
    fun intersects(other: BoundingBox): Boolean =
        south <= other.north && north >= other.south &&
            west <= other.east && east >= other.west
}
